// Ambiente DEVELOPMENT (rama csn_development). API: coaltapidev.clavisco.com
export const environment = {
  production: false,
  apiUrl: 'https://coaltapidev.clavisco.com/'
};
